module.exports = __webpack_public_path__ + "static/media/icon-toFinished-black.b1c09368.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/xkCoach/icon-toFinished-black.svg
// module id = 1670
// module chunks = 0